import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class FeedbackStatusFollowUpService {
  readonly rootUrl = AppSettings.webApiURL;
  constructor(public httpClient: HttpClient) { }

  getAccountManagersDDL() {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackStatusFollowUpAPI/GetAccountManagersDDL`);
  }

  getCustomersDDL(accountManager) {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackStatusFollowUpAPI/getCustomersDDL?accountManager=${accountManager==null?'':accountManager}`);
  }

  getData(accountManager, customer, statusAge) {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackStatusFollowUpAPI/getData?accountManager=${accountManager==null?'':accountManager}&customer=${customer==null?'':customer}&statusAge=${statusAge}`);
  }

  getDataTotals(accountManager, fromReportMonth, toReportMonth) {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackStatusFollowUpAPI/GetDataTotals?accountManager=${accountManager==null?'':accountManager}&FromReportMonth=${fromReportMonth}&ToReportMonth=${toReportMonth}`);
  }


  
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/feedback-status-followup.service.ts